import * as React from 'react';
import { CycleTemplate } from '../../action-steps';
import { useParams } from 'react-router-dom';
import { ICycle, State } from 'sections/offsite-campaigns/entities/offsiteCampaign';

interface OwnProps {
  segmentId: string;
  splitId: string;
  cycleIndex: number;
  cycle: ICycle;
  campaignState: State;
}

export type Props = OwnProps;

export const Cycle: React.FC<Props> = ({ segmentId, splitId, cycleIndex, cycle, campaignState }) => {
  const { siteId } = useParams<{ siteId: string }>();
  return (
    <CycleTemplate
      cycleIndex={cycleIndex}
      segmentId={segmentId}
      splitId={splitId}
      cycle={cycle}
      campaignState={campaignState}
      siteId={siteId}
    />
  );
};
